module.exports = __webpack_public_path__ + "img/Print.aba823ae.svg";